// redux/sagas/metalSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  getMetalsRequest,
  getMetalsSuccess,
  getMetalsFailure,
} from "../GetMetals/metalSlice";

function fetchMetalsApi() {
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/getMetals`,{
  });
}

// Saga worker
function* fetchMetalsWorker() {
  try {
    const response = yield call(fetchMetalsApi);
    const data = response.data.data;
    yield put(getMetalsSuccess(data));
  } catch (error) {
    yield put(getMetalsFailure(error?.response?.data?.message || error.message));
  }
}

export function* metalsSaga() {
  yield takeLatest(getMetalsRequest.type, fetchMetalsWorker);
}